
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcControlCertification', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.readOnly = '=?';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', function ($rootScope, $scope, $controller) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcControlCertification.[Template].tpl.html';
                $controller('BoxTmplController', { $scope: $scope });

                // Page is dirty
                $scope.ctxtCtrl = {};
                $scope.ctxtCtrl.needSaveChanges = false;
                $scope.ctxtCtrl.isSubmitting = false;

                $scope.pageIsDirty = function () {
                    $scope.ctxtCtrl.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                };
                $scope.pageIsNotDirty = function () {
                    $scope.ctxtCtrl.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                };
            }],
            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
